// this files inits listing page redux store and reducer in browser
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import getDataLayerMiddleware from './dataLayer';
import configurationReducers from './configuration.reduck';
import listingPageReducer from './listingPage.reduck';
import { initComparisonPersistence } from './comparisonPersistence';


const appReducer = combineReducers({
  configuration: configurationReducers,
  listingPage: listingPageReducer
});


const k = '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__';
const composeEnhancers =
  typeof window !== 'undefined' && window[k]
    ? window[k]
    : compose;

export function createAppStore(initState) {
  const enhancer = composeEnhancers(
    applyMiddleware(getDataLayerMiddleware(), thunk)
  );

  const appState = createStore(appReducer, initState, enhancer);

  initComparisonPersistence(appState);

  return appState;
}
